import React, {useState} from 'react';
import Logo from 'assets/images/khula-logo-badge-green.svg';
import NavigationService from 'services/NavigationService';
import {apiLOGIN} from 'constants/Api';
import TextField from '@material-ui/core/TextField';
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Container,
  CssBaseline,
  FormControlLabel,
  Link,
  makeStyles,
  Paper,
  Typography,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: theme.spacing(4),
    paddingTop: theme.spacing(0),
  },
  avatar: {
    width: 128,
    height: 128,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function LogIn() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleSignIn = (e: any) => {
    e.preventDefault(); // prevent http post on submit
    setLoading(true);
    apiLOGIN(username, password)
      .then((response) => {
        if (response.success) {
          NavigationService.navigate('/');
        } else {
          alert(response.message);
        }
      })
      .catch((signInError) => {
        console.log('Failed to sign in', signInError);
        alert('Unable to sign in at the moment. Please try again later');
      })
      .finally(() => setLoading(false));
  };

  return (
    <Container className="login-container" component="main" maxWidth="xs">
      <CssBaseline />
      <Paper className={classes.paper} variant="outlined">
        <Avatar className={classes.avatar} src={Logo} variant="square" />
        <Box mb={4} mt={-1}>
          <Typography component="h1" variant="subtitle1">
            Supplier Dashboard
          </Typography>
        </Box>
        <Typography component="h1" variant="h5">
          Sign In
        </Typography>
        <form className={classes.form} noValidate onSubmit={handleSignIn}>
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            onChange={(event) => setUsername(event.target?.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            name="password"
            label="Password"
            type={showPassword ? 'text' : 'password'}
            id="password"
            autoComplete="current-password"
            onChange={(event) => setPassword(event.target?.value)}
          />
          <Box display="flex">
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  onChange={(event, checked) => setShowPassword(checked)}
                />
              }
              label="Show password"
            />
          </Box>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            type="submit"
          >
            {loading ? (
              <CircularProgress color="inherit" size={24} thickness={6} />
            ) : (
              'Sign In'
            )}
          </Button>
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            mb={1}
            onClick={(event) => {
              NavigationService.navigate('forgot-password');
              event.stopPropagation();
            }}
          >
            <Link variant="body2">Forgot password?</Link>
          </Box>
          <Box display={'flex'} alignItems={'center'} justifyContent={'center'}>
            <Link
              href="mailto:support@khula.co.za?subject=Supplier%20Registration"
              variant="body2"
            >
              {"Don't have an account? Email support@khula.co.za"}
            </Link>
          </Box>
        </form>
      </Paper>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}

export function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://khula.co.za/">
        Khula!
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}
